export const messages = {
  en: {
    storeOrderCartReturn: {
      title: 'Return Order Management',
      queryConditions: 'Query Conditions',
      orderNumber: 'Order Number',
      selectStatus: 'Select Status',
      productName: 'Product Name',
      query: 'Query',
      reset: 'Reset',
      returnOrders: 'Return Orders',
      productReturn: 'Product Return',
      orderReturn: 'Order Return',
      orderId: 'Order ID',
      product: 'Product',
      userName: 'User Name',
      refundAmount: 'Refund Amount',
      orderStatus: 'Order Status',
      refundReason: 'Refund Reason',
      applyTime: 'Apply Time',
      operations: 'Operations',
      audit: 'Audit',
      details: 'Details',
      auditInfo: 'Audit Information',
      auditStatus: 'Audit Status',
      pleaseAudit: 'Please Audit',
      agree: 'Agree',
      reject: 'Reject',
      reason: 'Reason',
      requiredReason: 'Required, please fill in the reason',
      submit: 'Submit',
      cancel: 'Cancel',
      auditSuccess: 'Audit Success'
    }
  },
  zh: {
    storeOrderCartReturn: {
      title: '退货订单管理',
      queryConditions: '查询条件',
      orderNumber: '订单编号',
      selectStatus: '请选择状态',
      productName: '商品名称',
      query: '查询',
      reset: '重置',
      returnOrders: '退货订单',
      productReturn: '商品退货',
      orderReturn: '订单退货',
      orderId: '订单号',
      product: '商品名称',
      userName: '用户名称',
      refundAmount: '退款金额',
      orderStatus: '订单状态',
      refundReason: '退款原因',
      applyTime: '申请时间',
      operations: '操作',
      audit: '审核',
      details: '详情',
      auditInfo: '审核信息',
      auditStatus: '审核状态',
      pleaseAudit: '请审核',
      agree: '同意',
      reject: '拒绝',
      reason: '原因',
      requiredReason: '必填，请填写原因',
      submit: '提交',
      cancel: '取消',
      auditSuccess: '审核成功'
    }
  }
}